import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { useRemoveCaseMutation } from '@bvi/admin-panel/entities/cases/api-slice';
import { AdminPanelRoutesPaths } from '@bvi/admin-panel/shared/constants/routes';
import { ICaseListData } from '@bvi/api-interfaces/response/case';
import { ConfirmActionMenuItem } from '@bvi/common-components';

export interface IManagePendingCaseMenuProperties {
  case: ICaseListData;
}

export const ManagePendingCaseMenu: FC<IManagePendingCaseMenuProperties> = ({
  case: _case,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [removeCase, { isLoading: isRemoveCasePending }] =
    useRemoveCaseMutation();

  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const handleClickOnMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorElement(null);
  };

  const onRemoveCaseClick = async () => {
    await removeCase(_case.id);
  };

  return (
    <>
      <IconButton onClick={handleClickOnMenu}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() =>
            navigate(
              generatePath(AdminPanelRoutesPaths.CASES_EDIT, {
                id: String(_case.id),
              }),
            )
          }
        >
          {t('cases.list.actions.edit.caption')}
        </MenuItem>
        <ConfirmActionMenuItem
          question={t('pendingCases.list.actions.remove.question')}
          confirm={t('dialog.confirm')}
          cancel={t('dialog.cancel')}
          onClick={onRemoveCaseClick}
          componentProperties={{ disabled: isRemoveCasePending }}
        >
          {t('pendingCases.list.actions.remove.caption')}
        </ConfirmActionMenuItem>
      </Menu>
    </>
  );
};
